/**
 * A simple es6 module wrapper for Fetch
 */
export const fetch = window.fetch;
export default fetch;
